export default __webpack_public_path__ + "static/media/form-banner-2.574d203e.jpg";